import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSword = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 1597881708",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Subtract",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.74759 12.4888L8.39833 13.1396C8.68375 13.425 9.12167 13.4915 9.47893 13.3036L16.8344 9.43612C17.4919 9.0904 17.9037 8.40875 17.9037 7.6659L17.9037 4.33085C17.9037 3.22628 17.0082 2.33085 15.9037 2.33085L12.5693 2.33085C11.8261 2.33085 11.1442 2.74297 10.7986 3.40097L6.9347 10.7586C6.74761 11.1149 6.81399 11.5515 7.09854 11.836L7.74759 12.4851C7.7481 12.4856 7.7481 12.4864 7.74759 12.4869C7.74707 12.4875 7.74707 12.4883 7.74759 12.4888ZM16.6252 3.60906C16.3933 3.37717 16.0173 3.37717 15.7854 3.60906L8.4194 10.9751C8.18752 11.207 8.18752 11.5829 8.4194 11.8148C8.65129 12.0467 9.02726 12.0467 9.25915 11.8148L16.6252 4.4488C16.8571 4.21691 16.8571 3.84095 16.6252 3.60906Z",
			fill: ""
		}), /* @__PURE__ */ _jsx("path", {
			id: "Union",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.35777 10.8788C4.03546 10.5565 3.51288 10.5565 3.19057 10.8788C2.86825 11.2011 2.86825 11.7237 3.19057 12.046L4.64276 13.4982L2.6857 15.4552C2.10697 16.034 2.10697 16.9723 2.6857 17.551C3.26443 18.1297 4.20274 18.1297 4.78147 17.551L6.73853 15.5939L8.18637 17.0418C8.50869 17.3641 9.03126 17.3641 9.35358 17.0418C9.6759 16.7195 9.6759 16.1969 9.35358 15.8746L4.35777 10.8788Z",
			fill: ""
		})]
	})
});
export default SvgSword;
